import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = ["id", "name", "required", "value"]
const _hoisted_3 = { class: "o-form__item o-input-address-finder" }
const _hoisted_4 = ["id", "name", "placeholder", "autocomplete"]
const _hoisted_5 = { class: "o-form__validation" }
const _hoisted_6 = { class: "o-form__validation__required" }
const _hoisted_7 = { class: "o-form__validation__error" }
const _hoisted_8 = { class: "o-input -input-address" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  class: "o-form__instruction"
}
const _hoisted_14 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id) && _ctx.$root.canadaPost_APIKey)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass(((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass))
      }, [
        ($props.field.inputLabel != '')
          ? (_openBlock(), _createBlock(_component_inputlabel, {
              key: 0,
              field: $props.field
            }, null, 8 /* PROPS */, ["field"]))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.field.inputAddressMapping, (mapping, mi) => {
          return (_openBlock(), _createElementBlock("input", {
            class: "o-hidden-field-group",
            key: mi,
            id: 'input-' + mapping.fieldName + '-' + $props.field.id,
            name: ($props.repeaterIndex !== null) ? mapping.fieldName+'['+$props.repeaterIndex+']' : mapping.fieldName,
            required: (mapping.isRequired === true) ? 'required' : false,
            value: $options.getFieldValue(mapping.fieldCode),
            type: "text",
            autocomplete: "nope"
          }, null, 8 /* PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */)),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", _mergeProps({
              ref: "input",
              class: ["o-input", { 'readonly': $props.field.inputReadonly === true }]
            }, _toHandlers($data.readOnlyHandlers, true), {
              type: "text",
              id: 'input-'+$props.field.id,
              name: $props.field.inputName,
              placeholder: $props.field.inputPlaceholder,
              onInput: _cache[0] || (_cache[0] = $event => (_ctx.$refs.input.setCustomValidity(''))),
              autocomplete: ($props.field.inputAutocomplete && $props.field.inputAutocomplete != '' && $props.field.inputAutocomplete != 'querystring' && $props.field.inputAutocomplete != 'reactivevalue' && $props.field.inputAutocomplete != 'cookie') ? $props.field.inputAutocomplete : 'nope'
            }), null, 16 /* FULL_PROPS */, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx._t('L\'adresse sélectionnée semble invalide.')), 1 /* TEXT */)
            ])
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, !$data.isValid || $data.addressCardBody=='']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "o-input__close",
            style: {"float":"right"},
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($props.field.value=null), ["prevent"]))
          }, _hoisted_11),
          _createElementVNode("div", { innerHTML: $data.addressCardBody }, null, 8 /* PROPS */, _hoisted_12)
        ], 512 /* NEED_PATCH */), [
          [_vShow, $data.isValid && $data.addressCardBody!='']
        ]),
        ($props.field.inputInstructions && String($props.field.inputInstructions).trim() != '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
              _createElementVNode("small", {
                innerHTML: $props.field.inputInstructions
              }, null, 8 /* PROPS */, _hoisted_14)
            ]))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}